/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */
import IScene from "./scene_interface";
import GeoPath from "./elements/geo_path";
import IGeoPathsManager from "./geo_paths_manager_interface";

export default
class GeoPathsManager implements IGeoPathsManager {
    private _sceneAPI: IScene;
    private _geoPaths: GeoPath[];
    private _timeBudgetPerFrame: number;
    private _geoPathRefineToken: number;

    constructor(aSceneAPI: IScene) {
        this._sceneAPI = aSceneAPI;

        this._geoPaths = [];

        this._timeBudgetPerFrame = 40; // ms when camera is not moving
        this._geoPathRefineToken = 0;
    }

    public createGeoPath(aProperties: any) {
        let geoPathAPIElement: any = this._sceneAPI.getDocument().createAPIElement(GeoPath.TypeName);
        if (aProperties !== undefined && aProperties !== null) {
            geoPathAPIElement.extendProperties(aProperties);
        }

        // set the internal modelID and internal layer by default for the new API element
        this._sceneAPI.getDocument().attachElementToInternalModel(geoPathAPIElement);
        this._geoPaths.push(geoPathAPIElement);

        return geoPathAPIElement;
    }

    public remove(aGeoPath: GeoPath) {
        for (let i = 0; i < this._geoPaths.length; i++) {
            if (this._geoPaths[i].getUID() === aGeoPath.getUID()) {
                this._geoPaths.splice(i, 1);
                return;
            }
        }
    }

    public tick() {
        let timePassed = 0;
        for (let i = this._geoPathRefineToken; i < this._geoPaths.length && timePassed <= this._timeBudgetPerFrame; i++) {
            //if (this._geoPaths[i].needsRefine()) {
            timePassed += this._geoPaths[i].refine(20);
            //}
        }

        this._geoPathRefineToken++;

        if (this._geoPathRefineToken >= this._geoPaths.length) {
            this._geoPathRefineToken = 0;
        }
    }
}
